import { render } from "./RateMask.vue?vue&type=template&id=2a2760a0&scoped=true"
import script from "./RateMask.vue?vue&type=script&lang=js"
export * from "./RateMask.vue?vue&type=script&lang=js"

import "./RateMask.vue?vue&type=style&index=0&id=2a2760a0&scoped=true&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2760a0"]])

export default __exports__